const runtimeCrypto = () => typeof crypto === "undefined" ? undefined : crypto;
const bytesToHex = (bytes) => Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");

export const sha256 = async (value, cryptoRuntime = runtimeCrypto()) => {
  const bytes = typeof value === "string" ? new TextEncoder().encode(value) : new Uint8Array(value);
  if (typeof cryptoRuntime?.subtle?.digest === "function") {
    try {
      return bytesToHex(new Uint8Array(await cryptoRuntime.subtle.digest("SHA-256", bytes)));
    } catch (_error) {
      // LAN HTTP origins can expose crypto while withholding or blocking SubtleCrypto.
    }
  }
  const { sha256: sha256Fallback } = await import("@noble/hashes/sha256");
  return bytesToHex(sha256Fallback(bytes));
};

export const hashFile = async (file, cryptoRuntime = runtimeCrypto()) => sha256(await file.arrayBuffer(), cryptoRuntime);

export const canCreateSecureId = (cryptoRuntime = runtimeCrypto()) => Boolean(
  typeof cryptoRuntime?.randomUUID === "function" || typeof cryptoRuntime?.getRandomValues === "function",
);

export const createSecureId = (cryptoRuntime = runtimeCrypto()) => {
  if (typeof cryptoRuntime?.randomUUID === "function") return cryptoRuntime.randomUUID();
  if (typeof cryptoRuntime?.getRandomValues !== "function") throw new Error("Secure random values are unavailable.");
  const bytes = cryptoRuntime.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = bytesToHex(bytes);
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};
